// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__VCh7Y","header":"PatientQuestionnaire_header__19NpI","info":"PatientQuestionnaire_info__3kxzT"};